import * as React from "react";

function VCMontreal(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.98 6.907L10.25.137c-.173-.173-.37-.187-.543-.015L-.001 6.908v11.994c0 .73.55 1.05 1.288 1.05h3.929a.433.433 0 00.434-.43v-3.979h8.712v4.02a.44.44 0 00.435.437h3.827c.736 0 1.354-.604 1.354-1.312 0-.005.044-9.398.003-11.78z"
        fill="currentColor"
      />
      <path
        d="M17.684 18.54h-1.91v-3.767c-.087-.45-.743-.604-.96-.604H5.186c-.274-.017-.84.23-.93.637v3.733h-1.94c-.47 0-.803-.337-.803-.546V7.691c.075-.117 8.496-5.702 8.496-5.702l8.496 5.702-.002 10.302c0 .39-.367.547-.82.547z"
        fill="#fff"
      />
      <path
        d="M7.11 11.069c.042.098.082.196.122.295.04-.102.08-.201.124-.302.042-.1.087-.192.136-.284L9.31 7.374a.414.414 0 01.07-.101.216.216 0 01.08-.056.341.341 0 01.1-.021c.037-.002.08-.004.132-.004h.863v6.144H9.548V9.367a5.148 5.148 0 01.026-.51l-1.857 3.485a.483.483 0 01-.166.183.42.42 0 01-.238.067h-.158a.422.422 0 01-.238-.066.479.479 0 01-.166-.184L4.869 8.845c.01.092.019.184.023.274.004.088.006.171.006.247v3.97H3.89V7.191h.863c.05 0 .094.002.13.004.038.003.07.01.1.021a.24.24 0 01.084.056c.026.025.05.059.072.1l1.836 3.414c.049.092.094.185.134.283zM16.128 7.191v.94h-1.85v5.205h-1.142V8.131h-1.858v-.94h4.85z"
        fill="currentColor"
      />
    </svg>
  );
}

export default VCMontreal;